module.exports = __webpack_public_path__ + "img/pic-05.416e4fc9.png";